import { Space } from 'antd'
import { Link } from 'react-router'
import { useAdminTranslate } from '@/providers/i18n-provider'

export interface TitleProps {
  collapsed: boolean
}

export const Title = ({ collapsed }: TitleProps) => {
  const translate = useAdminTranslate()

  return (
    <Link to="/" style={{ display: 'block', padding: collapsed ? '15px 0' : '15px 10px' }}>
      <Space size={10}>
        <img className="admin-brand-mark" src="/logo-mark.svg" alt="" />
        {collapsed ? null : (
          <span className="admin-brand-copy">
            <strong>{translate('common.brand.name')}</strong>
            <span>{translate('admin.login.brandSuffix')}</span>
          </span>
        )}
      </Space>
    </Link>
  )
}
